<div class="system-container" [ngClass]="{ 'full-height': isFullHeight }">
  <!-- Connecting Icon & the ripple elect -->
  <div *ngIf="bigIcon">
    <div class="connect-icon" *ngIf="rippleEffect">
      <div class="ripple-div"></div>
      <div class="ripple-div"></div>
      <div class="ripple-div"></div>
      <div class="ripple-div"></div>
      <img src="{{ bigIcon }}" alt="{{ bigIconAltText }}" class="pulse-img" />
    </div>
    <div class="inernet-outage-modem" *ngIf="!rippleEffect">
      <div
        [ngClass]="
          'internet-outage-modem-image' +
          (whixScore > 0 ? ' whix-background' : '')
        "
      >
        <img
          src="{{ bigIcon }}"
          alt="{{ bigIconAltText }}"
          class="modem-image"
        />
      </div>
    </div>
  </div>
  <!-- Header -->
  <div class="header-div" *ngIf="messageTitle">
    <span
      class="status-icon"
      *ngIf="isSystemFeedbackSuccess || isSystemFeedbackError"
    >
      <ds-icon
        *ngIf="isSystemFeedbackSuccess"
        [name]="'checkmark-filled'"
        [color]="'success'"
        [ariaHidden]="false"
      ></ds-icon>
      <ds-icon
        *ngIf="isSystemFeedbackError"
        [name]="'error-filled'"
        [color]="'error'"
        [ariaHidden]="false"
      ></ds-icon>
    </span>
    <span [innerHTML]="messageTitle"></span>
  </div>

  <!-- Body -->
  <div class="cardtext-container">
    <div class="body-text" *ngIf="cardText" [innerHTML]="cardText"></div>
    <div class="wifi-rating" *ngIf="whixScore > 0">
      <div class="bar bar1" [ngClass]="{ barbackground: whixScore >= 1 }"></div>
      <div class="bar bar2" [ngClass]="{ barbackground: whixScore >= 2 }"></div>
      <div class="bar bar3" [ngClass]="{ barbackground: whixScore >= 3 }"></div>
      <div class="bar bar4" [ngClass]="{ barbackground: whixScore >= 4 }"></div>
      <div
        class="bar bar5"
        [ngClass]="{ barbbackground: whixScore >= 5 }"
      ></div>
    </div>
  </div>
  <div class="body-text" *ngIf="queuePosition">
    <p>{{ queuePosition }}</p>
  </div>
  <div class="body-text" *ngIf="estimatedTime">
    <p>{{ estimatedTime }}</p>
  </div>
  <div class="padding-top">
    <ng-container *ngIf="cannedResponses?.length">
      <button
        *ngFor="let response of cannedResponses"
        ucxJsHighlight
        ucx-button
        class="response-btn"
        (click)="cannedResponseClick(response)"
      >
        {{ response.value }}
      </button>
    </ng-container>
  </div>
</div>
